import { buildHeader } from './buildHeader.js';
import { buildChapters } from './buildChapters.js';
import { buildFooter } from './buildFooter.js';

export function buildStoryDOM(config) {
  const story = document.getElementById('story');
  if (!story) {
    console.warn("Element with id 'story' not found.");
    return;
  }

  const features = document.createElement('div');
  features.id = 'features';

  const header = buildHeader(config);
  const chapters = buildChapters(config); // returns array of chapter elements
  const footer = buildFooter(config);

  chapters.forEach(chap => features.appendChild(chap));

  story.innerHTML = ''; // Optional: clear previous content if needed
  if (header) story.appendChild(header);
  story.appendChild(features);
  if (footer) story.appendChild(footer);
}


